import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "bg-color-rejected text-white border border-red-400 px-4 py-3 rounded relative",
  role: "alert"
}
const _hoisted_2 = { class: "block sm:inline" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { class: "absolute top-0 bottom-0 right-0 px-4 py-3" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.content), 1),
    _hoisted_3
  ]))
}